const LineItemsModel = {
    variant: (variantId, items = {}) => items.filter((item) => item.type === 'variant' && variantId === item.id)[0],

    lineItems: (lineItemsIds, items = {}) => items.filter((item) => item.type === 'line_item' && lineItemsIds.indexOf(item.id) !== -1),

    images: (imagesIds, items = {}) => items.filter((item) => item.type === 'image' && imagesIds.indexOf(item.id) !== -1),

    product: (productId, items = {}) => items.filter((item) => item.type === 'product' && productId === item.id)[0],

    data_extras: (dataExtrasIds, items = {}) => items.filter((item) => item.type === 'data_extra' && dataExtrasIds.indexOf(item.id) !== -1),

    data_extra_types: (dataExtrasIds, items = {}) => items.filter((item) => item.type === 'data_extra_type' && dataExtrasIds.indexOf(parseInt(item.id, 10)) !== -1),

};

export default LineItemsModel;



/** WEBPACK FOOTER **
 ** ./src/services/line-items.js
 **/